import { render } from "./Calendar_Dialog.vue?vue&type=template&id=06145b25&scoped=true&ts=true"
import script from "./Calendar_Dialog.vue?vue&type=script&lang=ts"
export * from "./Calendar_Dialog.vue?vue&type=script&lang=ts"

import "./Calendar_Dialog.vue?vue&type=style&index=0&id=06145b25&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06145b25"]])

export default __exports__